import React from "react";
import { Form } from "react-bootstrap";

class Input extends React.Component {
  state = {};
  radioHelper = () => {
    let radios = this.props.options.map((opt, index) => {
      return (
        <button
          type="button"
          key={`${this.props.name}${index}`}
          onClick={this.props.change}
          name={this.props.name}
          value={opt}
          aria-pressed={opt === this.props.value}
          //data-pt-name={this.props.dataptname}
          className={`${this.props.className} opt-${opt}`}
        >
          <span className="sr-only">{this.props.label[index]}</span>
        </button>
      );
    });
    return <Form.Group>{radios}</Form.Group>;
  };
  render() {
    return this.radioHelper();
  }
}

export default Input;
